import Client from "./Clients/AxiosClient";
const resource = "/api/v1/user/profile";

export default {
  get() {
    return Client.get(`${resource}`);
  },
  uploadPhoto(file) {
    const formData = new FormData();
    formData.append("avatar", file);
    return Client.post(`${resource}/upload-avatar`, formData);
  },
  update(data) {
    return Client.put(`${resource}/update`, data);
  },
  updatePassword(data) {
    return Client.post(`${resource}/update-password`, data);
  },
};
